import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../../../components/Header';
import MasterSidebar from './MasterSidebar';

const MasterSection: React.FC = () => (
  <div className="flex-1 flex flex-col overflow-hidden">
    <Header title="Master" />
    <div className="flex min-h-full flex-1 bg-gray-50">
      <MasterSidebar />
      <div className="flex-1 overflow-auto">
        <Outlet />
      </div>
    </div>
  </div>
);

export default MasterSection;
